import type { IInputQuestion } from './_question';
import type { ISliderProps } from '../Inputs/Slider';

import React from 'react';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';

import Hint from '../Hint';
import Slider from '../Inputs/Slider';

import Title from './elements/Title';

import getControlError from '$/hooks/getControlError';

const DEFAULT_DISABLED_MESSAGE =
  'Du hast bereits das gesamte Limit aufgebraucht, geh bitte zur Zusammenfassung.';

export const yupSliderInputQuestion = yup
  .number()
  .transform((value: number | string): number | undefined =>
    typeof value === 'number' ? value : undefined
  );

interface ISliderInputQuestion
  extends IInputQuestion,
    Omit<ISliderProps, 'name' | 'onChange' | 'value'> {
  disabledMessage?: string | null;
}

const SliderInputQuestion = ({
  control,
  name,
  title,
  disabledMessage = DEFAULT_DISABLED_MESSAGE,
  ...props
}: ISliderInputQuestion) => {
  const disabled = props.disabled || props.max < props.min;

  return (
    <>
      {title && <Title disabled={disabled}>{title}</Title>}
      <Controller
        control={control}
        name={name}
        defaultValue=""
        render={({ field, fieldState }) => {
          const error = getControlError(control, name, props.errorMessage);

          const onChange = (n: number | string) => {
            if (disabled || n === '') {
              return;
            }
            const value = Number(n);
            if (value < props.min) {
              field.onChange(props.min);
              return;
            }
            if (value > props.max) {
              field.onChange(props.max);
              return;
            }
            field.onChange(value);
          };

          const minMaxError = disabled
            ? {
                style: {
                  opacity: '0.7',
                },
                error: false,
                disabled: true,
              }
            : {};

          return (
            <Slider
              {...field}
              {...fieldState}
              onChange={onChange}
              {...props}
              {...minMaxError}
              disabled={disabled}
              errorMessage={error.message}
            />
          );
        }}
      />
      {/* TODO: Refactor to somehow error message with hint, maybe based on type */}
      <Hint
        style={{ display: disabled ? 'flex' : 'none' }}
        text={disabledMessage}
      />
    </>
  );
};

Slider.defaultProps = {
  step: 0.1,
  min: 1,
  max: 4,
  numberInput: true,
};

export default SliderInputQuestion;
